export function getUserInitials(name?: string | null): string {
  if (!name?.trim()) return '?'
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 1) return (parts[0][0] ?? '?').toUpperCase()
  const first = parts[0][0] ?? ''
  const last = parts.length === 2 ? parts[1][0] : parts[parts.length - 1][0]
  return (first + (last ?? '')).toUpperCase() || '?'
}
